import React, { useState, useContext, useEffect } from "react";
import PAContentBlock from "../PAContentBlock";

import PAgameKeysWidg from "./PAgameKeysWidg";
import { withRouter } from "react-router-dom";
import { CardFlatten } from "../PAcardNew";
import DistributionBlocker from "./DistributionBlocker";

import {
  Button,
  Card,
  Tooltip,
  Input,
  RadioGroup,
  Icon,
  Switch,
  Notification,
  ButtonAction,
  FormGroup
} from "xsolla-uikit";

import { KeyContext } from "./PAgameKeys";
import { GlobalContext } from "../PA";

import PAsbStartPopup from "../PAsbStartPopup";



export default function ({
  sku,
  platformsEnabled,
  globalAgreement,
  handleCurrentState = () => {
    void 0;
  },
  match,
  ...props
}) {
  console.log('props123 = ', props);
  let keyContext = useContext(KeyContext);
  let globalContext = useContext(GlobalContext);

  let [state, setState] = useState({
    ...globalContext,
    sandbox: false,
    platformsEnabled: false,
    sbOpened: false,
    active: "visual",
    // globalAgreement: globalAgreement
  });

  useEffect(() => {
    console.log('state = ', state);
    // if (state.sbOpened) {setState({
    //   sbOpened: false,
    // })}
    //  debugger;
    // if (handleCurrentState !== state.handleCurrentState) {
      //   setState({
        //     ...state,
        //     handleCurrentState: handleCurrentState
        //   })
        // }
      });

  const handleModal = (e) => {
    console.log('e = ', e.target);

    state.sbOpened = false;
    // setState({
    //   ...state,
    //   sbOpened: false
    // });
  }


  let enabled = globalContext.globalState.store.gameKeys.keys[sku]
    ? globalContext.globalState.store.gameKeys.keys[sku].keyData[
        "platformsEnabled"
      ]
    : null;
  let webhooksNeeded = globalContext.globalState.globalWebhooks.needed;
  let webhooksEnabled = globalContext.globalState.globalWebhooks.value;
  let agreement = globalContext.globalState.globalAgreement.value;

  return (
    <div
      // style={{ opacity: platformsEnabled ? 1 : "0.3" }}
      // style={{ opacity: platformsEnabled ? 1 : "0.3" }}
      className="xsui-content-block xsui-content-block--appearance-primary xsui-form-group--indentation-lg"
    >
      {globalContext && (
        <div className="xsui-content-block__entry xsui-form-group--indentation-lg">
          <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-md ui-navigation--bordered">
            <div className="xsui-form-group__entry">
              <div>
                <div className="xsui-breadcrumbs xsui-form-group--indentation-md">
                  <div className="xsui-breadcrumbs_entry">
                    <div className="xsui-breadcrumbs_item">
                      <a
                        name="widget"
                        className="xsui-breadcrumbs_label"
                        href="/2340/projects/40702/storefront/pay2play"
                      >
                        Distribution
                      </a>
                      <div className="xsui-breadcrumbs_chevron">
                        <i
                          className="xsui-icon xsui-icon-chevron"
                          style={{ fontSize: 24, color: "inherit" }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* <div className="">
                  <FormGroup label="" indentation="md">
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Switch
                        name="switch_1"
                        input={{
                          value: state.sandbox,
                          onChange: e => {
                            setState({
                              sandbox: !state.sandbox
                            });
                          }
                        }}
                      />
                      Sandbox mode
                      <div style={{ marginLeft: 4 }}>
                        <Tooltip
                          distance={12}
                          label="Enables everything, but not real"
                        />
                      </div>
                    </div>
                  </FormGroup>
                </div> */}
                </div>
              </div>
            </div>
          </div>

          <PAContentBlock title="Link to checkout" border={true}>
            <FormGroup indentation="sm">
              <Input
                input={{
                  disabled: true,
                  // name: 'with-icon',
                  value: "xsolla.com/paystation/action...",
                  // extraLabel: this.currLocked ? "DEFAULT" : null
                  onChange: () => {
                    void 0;
                  }
                }}
                offset="right"
                extra={
                  <Icon
                    name={"copy"}
                    hoverable={true}
                    // onClick={e => this.handeCurrDel(this.id, e)}
                  />
                }
              />
            </FormGroup>
            <p>
              You can add this link to your website to open the payment
              interface directly.
            </p>

            <FormGroup indentation="md">
              <DistributionBlocker
enabled = {globalContext.globalState.store.gameKeys.keys[sku] ? globalContext.globalState.store.gameKeys.keys[sku].keyData["platformsEnabled"]
: null}
webhooksNeeded = {globalContext.globalState.globalWebhooks.needed}
webhooksEnabled = {globalContext.globalState.globalWebhooks.value}
agreement = {globalContext.globalState.globalAgreement.value}
              />
            </FormGroup>

            <FormGroup indentation="md">
              <Button
                disabled={
                  !(
                    state &&
                    (!enabled ||
                    (webhooksNeeded && !webhooksEnabled) ||
                    !agreement)
                  ) || state.sandbox
                    ? false
                    : true
                }
                size="sm"
                type="submit"
                icon="new-tab"
                appearance="secondary"
                // onClick={e =>
                // this.updateStatus("save and close")
                // }
              >
                Test link
              </Button>
            </FormGroup>
          </PAContentBlock>

          <PAContentBlock title="Embeddable Widget" border={true}>
            <FormGroup indentation="xs">
              <div className="ui-navigation ui-navigation--size-md ui-navigation--bordered">
                <div className="ui-navigation__menu">
                  <div className="ui-navigation__section">
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setState({
                          ...state,
                          active: "visual"
                        });
                      }}
                      className={`ui-navigation__item ${
                        state.active === "visual"
                          ? "ui-navigation__item--active"
                          : ""
                      }`}
                    >
                      Widget visual
                    </div>
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setState({
                          ...state,
                          active: "code"
                        });
                      }}
                      className={`ui-navigation__item ${
                        state.active === "code"
                          ? "ui-navigation__item--active"
                          : ""
                      }`}
                    >
                      Widget code
                    </div>
                  </div>
                  <div className="ui-navigation__section ui-navigation__section--actions" />
                </div>
              </div>
            </FormGroup>

            <PAgameKeysWidg keys={state.platformsEnabled} />

            <FormGroup indentation="md">

            <DistributionBlocker
              enabled = {globalContext.globalState.store.gameKeys.keys[sku] ? globalContext.globalState.store.gameKeys.keys[sku].keyData["platformsEnabled"]
              : null}
              webhooksNeeded = {globalContext.globalState.globalWebhooks.needed}
              webhooksEnabled = {globalContext.globalState.globalWebhooks.value}
              agreement = {globalContext.globalState.globalAgreement.value}
              />

            </FormGroup>


            <FormGroup>
              <div className="p2p-widget">
                <div className="p2p-widget__code"><pre><code>{"\n"}{"      "}&lt;div id="XS-pay2play-widget"&gt;&lt;/div&gt;{"\n"}{"      "}&lt;script&gt;{"\n"}{"          "}var options = {"{"}{"\n"}{"              "}access_data: {"{"}{"\n"}{"                "}"settings": {"{"}{"\n"}{"                  "}"project_id": 37471{"\n"}{"                "}{"}"},{"\n"}{"                "}"purchase": {"{"}{"\n"}{"                  "}"pin_codes": {"{"}{"\n"}{"                    "}"codes":[{"{"}"digital_content": "My_awesome_game"{"}"}]{"\n"}{"                  "}{"}"}{"\n"}{"                "}{"}"},{"\n"}{"                "}"user": {"{"}{"\n"}{"                  "}"country": {"{"}{"\n"}{"                    "}"allow_modify": false{"\n"}{"                  "}{"}"}{"\n"}{"                "}{"}"}{"\n"}{"              "}{"}"},{"\n"}{"              "}theme : {"{"}{"\n"}{"                  "}foreground: "green",{"\n"}{"                  "}background: "light"{"\n"}{"              "}{"}"},{"\n"}{"              "}lightbox: {"{"}{"\n"}{"                  "}height: "700px",{"\n"}{"                  "}spinner: "round"{"\n"}{"              "}{"}"},{"\n"}{"              "}target_element: "#XS-pay2play-widget"{"\n"}{"          "}{"}"};{"\n"}{"          "}var s = document.createElement("script");{"\n"}{"          "}s.type = "text/javascript";{"\n"}{"          "}s.async = true;{"\n"}{"          "}s.src = "https://static.xsolla.com/embed/pay2play/2.2.2/widget.min.js";{"\n"}{"          "}s.addEventListener("load", function (e) {"{"}{"\n"}{"              "}var widgetInstance = XPay2PlayWidget.create(options);{"\n"}{"          "}{"}"}, false);{"\n"}{"          "}var head = document.getElementsByTagName("head")[0];{"\n"}{"          "}head.appendChild(s);{"\n"}{"      "}&lt;/script&gt;{"\n"}{"      "}</code></pre><div className="p2p-widget__code__copy-button"><button type="button" className="ui-form__button ui-form__button--default ui-form__button--normal ui-form__button--blue ui-form__button--inline undefined"><img src="//cdn.xsolla.net/publisher-v4/duplicate-single-white.858677.svg" />Copy widget code</button></div></div>
              </div>
            </FormGroup>


            <FormGroup indentation="md">
              <Button
                disabled={
                  !(
                    !enabled ||
                    (webhooksNeeded && !webhooksEnabled) ||
                    !agreement
                  ) || state.sandbox
                    ? false
                    : true
                }
                size="sm"
                type="submit"
                icon="copy"
                appearance="secondary"
                // onClick={e =>
                // this.updateStatus("save and close")
                // }
              >
                Copy Widget Code
              </Button>
            </FormGroup>
          </PAContentBlock>

          <PAContentBlock title="Landing page" border={true}>
            <FormGroup indentation="sm">
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gridTemplateRows: "140px",
                  gridColumnGap: "1.6%",
                  gridRowGap: "20px",
                  width: "100%"
                }}
                onClick={() => {
                  setState({
                    ...state,
                    sbOpened: true
                  });
                }}
              >


<SiteBuilderCreate>
  <CardFlatten
    title="Create Landing Page"
  />
</SiteBuilderCreate>

              </div>
            </FormGroup>
          </PAContentBlock>
        </div>
      )}
    </div>
  )
}







const SiteBuilderCreate = ({children}) => {
  let [state, setState] = useState({
    opened: false
  });

  const handleModal = () => {
    setState({
      opened: false
    });
  }

  return (
    <div>
      <span onClick={() => {
        setState({
          opened: true
        });
      }}>
        {children && children}
        {!children &&
        <Button>
        Create Site
      </Button>}
      </span>
      {state.opened && <PAsbStartPopup handleModal={handleModal} />}
    </div>
  )
}










// export default withRouter(props => <PAgameKeysDistr {...props} />);